const roles = {
  admin: "admin",
  attendee: "attendee",
  caregiver: "caregiver",
  doctoAdmin: "admin",
  doctor: "doctor",
  patient: "patient",
};
export default roles;
